import _ from 'lodash';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './TabList.scss';
import classNames from 'classnames';

export default class TabList extends Component {
    static propTypes = {
        value: PropTypes.any.isRequired,
        options: PropTypes.array.isRequired,
        onChange: PropTypes.func.isRequired
    };

    render() {
        const {options} = this.props;

        return (
            <div className={styles.tabList}>
                {options.map(this.renderOptionTab)}
            </div>
        );
    }

    renderOptionTab = (option, index) => {
        const {value, onChange} = this.props;
        const selected = value === option.value;

        const className = classNames(styles.tabListItem, {
            [styles.tabListItemSelected]: selected
        });

        return (
            <div key={index}
                 className={className}
                 onClick={_.partial(onChange, option.value)}>
                {loc(option.key)}
            </div>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/controls/TabList.jsx